import { Alert } from '@interstate/components/Alert';
import { Typography } from '@interstate/components/Typography';
import { RESIDUAL_DOLLAR } from '@makemydeal/dr-platform-types';
import type { ResidualValueType } from '@makemydeal/dr-platform-types';

import { DOLLAR_RESIDUAL_WARNING_MESSAGE, DOLLAR_RESIDUAL_WARNING_TESTID } from './constants';

export type DollarResidualWarningProps = {
    displayedType: ResidualValueType;
};

export const DollarResidualWarning = ({ displayedType }: DollarResidualWarningProps) => {
    if (displayedType !== RESIDUAL_DOLLAR) {
        return null;
    }

    return (
        <Alert type="caution" data-testid={DOLLAR_RESIDUAL_WARNING_TESTID} sx={{ marginBottom: '1rem' }}>
            <Typography variant="body-sm">{DOLLAR_RESIDUAL_WARNING_MESSAGE}</Typography>
        </Alert>
    );
};
